export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "最新地址",
    slug: "latest-address",
    description: "91.con 最新可用地址实时更新，包含主域名与备用镜像地址，确保您随时可以正常访问平台。",
    icon: "ri-links-line",
    articleCount: 12,
  },
  {
    id: "cat-2",
    name: "访问指引",
    slug: "access-guide",
    description: "详细的 91.con 访问操作指引，涵盖桌面端、移动端、不同浏览器与网络环境下的访问方法。",
    icon: "ri-compass-3-line",
    articleCount: 8,
  },
  {
    id: "cat-3",
    name: "安全须知",
    slug: "safety-tips",
    description: "识别虚假钓鱼网站、保护个人隐私、安全访问注意事项，让您远离网络风险。",
    icon: "ri-shield-check-line",
    articleCount: 10,
  },
  {
    id: "cat-4",
    name: "常见问题",
    slug: "faq",
    description: "汇总用户最常遇到的问题与解答，包括无法访问、地址失效、账号安全等热点话题。",
    icon: "ri-question-answer-line",
    articleCount: 15,
  },
  {
    id: "cat-5",
    name: "使用教程",
    slug: "tutorials",
    description: "从注册到高级使用的完整图文教程，帮助新老用户快速上手 91.con 各项功能。",
    icon: "ri-book-open-line",
    articleCount: 6,
  },
];